void

function (global) {
    var extend,
        _extend,
        _isObject;

    _isObject = function (o) {
        return Object.prototype.toString.call(o) === '[object Object]';
    }

    _extend = function self(destination, source) {
        var property;
        for (property in destination) {
            if (destination.hasOwnProperty(property)) {

                // 若destination[property]和sourc[property]都是对象，则递归
                if (_isObject(destination[property]) && _isObject(source[property])) {
                    self(destination[property], source[property]);
                };

                // 若sourc[property]已存在，则跳过
                if (source.hasOwnProperty(property)) {
                    continue;
                } else {
                    source[property] = destination[property];
                }
            }
        }
    }

    extend = function () {
        var arr = arguments,
            result = {},
            i;

        if (!arr.length) return {};

        for (i = arr.length - 1; i >= 0; i--) {
            if (_isObject(arr[i])) {
                _extend(arr[i], result);
            };
        }

        arr[0] = result;
        return result;
    }

    global.extend = extend;

    function index(dom) {
        var index = 0;
        while ((dom = dom.previousSibling) && dom.nodeType !== 9) {
            if (dom.nodeType == 3) continue;
            index++;
        }
        return index;
    }

    global.index = index;


    if (!("classList" in document.documentElement)) {
        Object.defineProperty(Element.prototype, 'classList', {
            get: function () {
                var self = this;

                function update(fn) {
                    return function (value) {
                        var classes = self.className.split(/\s+/g),
                            index = classes.indexOf(value);

                        fn(classes, index, value);
                        self.className = classes.join(" ");
                    }
                }

                return {
                    add: update(function (classes, index, value) {
                        if (!~index) classes.push(value);
                    }),

                    remove: update(function (classes, index) {
                        if (~index) classes.splice(index, 1);
                    }),

                    toggle: update(function (classes, index, value) {
                        if (~index)
                            classes.splice(index, 1);
                        else
                            classes.push(value);
                    }),

                    contains: function (value) {
                        return !!~self.className.split(/\s+/g).indexOf(value);
                    },

                    item: function (i) {
                        return self.className.split(/\s+/g)[i] || null;
                    }
                };
            }
        });
    }

    if (!Array.prototype.filter) {
        Array.prototype.filter = function (callback) {
            // 获取数组长度
            var len = this.length;
            if (typeof callback != "function") {
                throw new TypeError();
            }
            // 创建新数组，用于承载经回调函数修改后的数组元素
            var newArr = new Array();
            // thisArg为callback 函数的执行上下文环境
            var thisArg = arguments[1];
            for (var i = 0; i < len; i++) {
                if (i in this) {
                    if (callback.call(thisArg, this[i], i, this)) {
                        newArr.push(val);
                    }
                }
            }
            return newArr;
        }
    }

}(window);

window.console = window.console || (function () {
    var c = {};
    c.log = c.warn = c.debug = c.info = c.error = c.time = c.dir = c.profile = c.clear = c.exception =
        c.trace = c.assert = function () {};
    return c;
})();
/**
 * toast
 */
window.toast = function (text) {
        var $toast = document.createElement('DIV');
        $toast.setAttribute('class', 'global-toast md-effect-1');
        var $toastContent = document.createElement('DIV');
        $toastContent.setAttribute('class', 'toast-content');
        $toastContent.innerHTML = text;
        $toast.appendChild($toastContent);
        document.body.appendChild($toast);
        $toast.classList.add('global-toast-show');
        var t = setTimeout(function () {
            $toast.classList.remove('global-toast-show');
            setTimeout(function () {
                $toast.parentNode.removeChild($toast);
            }, 1000)
            clearTimeout(t);
        }, 2000);
    };
    /**
     * confirm
     */
window.confirm = function (text, successCb) {
    var $confirm = document.createElement('div');
    $confirm.setAttribute('class', 'global-confirm ');

    var tpl =
        '<div class="comfirm-ctx">\
            <i class="close"></i>\
            <div class="title"></div>\
            <div class="btn-group">\
                <a href="javascript:void(0)" class="btn btn-cfm">是</a>\
                <a href="javascript:void(0)" class="btn btn-cancel">否</a>\
            </div>\
        </div>';

    $confirm.innerHTML = tpl;

    document.body.appendChild($confirm);

    var $title = $confirm.querySelector('.title');
    $title.innerHTML = text;

    var $cancel = $confirm.querySelector('.btn-cancel');
    var $close = $confirm.querySelector('.close');

    $close.onclick = $cancel.onclick = function () {
        remove();
    }

    var $cfm = $confirm.querySelector('.btn-cfm');
    $cfm.onclick = function () {
        successCb && successCb();
        remove();
    }
    $confirm.classList.add('global-confirm-show');

    function remove() {
        $confirm.classList.remove('global-confirm-show');

        setTimeout(function () {
            $confirm.parentNode.removeChild($confirm);

        }, 500)
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/assets/ui.js
// module id = 5
// module chunks = 0